'use client';

import React, { createContext, type FC, type ReactNode, useEffect, useState } from 'react';

interface MediaQueryContextFields {
    mobile: boolean;
    desktop: boolean;
}

interface MediaQueryProps {
    children: ReactNode;
}

export const MediaQueryContext = createContext<MediaQueryContextFields>({
    mobile: false,
    desktop: false,
});

export const MediaQuery: FC<MediaQueryProps> = ({ children }) => {
    const [resolution, setResolution] = useState<MediaQueryContextFields>({ mobile: false, desktop: false });

    useEffect(() => {
        const media = matchMedia('(min-width: 992px)');

        const updateResolution = (): void => {
            setResolution({
                mobile: !media.matches,
                desktop: media.matches,
            });
        };

        updateResolution();
        media.addEventListener('change', updateResolution);

        return (): void => {
            media.removeEventListener('change', updateResolution);
        };
    }, []);

    return <MediaQueryContext.Provider value={resolution}>{children}</MediaQueryContext.Provider>;
};
